import Container from '../../../elements/Container'
import SlickSlider from '../../../elements/SlickSlider'
import Column from '../../../layout/Column'
import Columns from '../../../layout/Columns'
import Item from './components/Item'
import { useResponsive } from '../../../../providers/ResponsiveContext'
import styles from './styles.module.scss'
import { useEffect, useState } from 'react'

const Services = ({ services }) => {
  const { isTablet, isSmallMobile, isDesktop } = useResponsive()

  const [loaded, setLoaded] = useState(false)
  useEffect(() => setLoaded(true), [])

  if (isTablet && services && loaded) {
    return (
      <SlickSlider
        className={styles.experience}
        arrows={false}
        pagination
        infinite={false}
        variableWidth={true}
        slidesToScroll={isSmallMobile ? 1 : 2}
        slidesToShow={isSmallMobile ? 1 : 2}
      >
        {services.map((item, index) => (
          <Item key={`service-${index}`} item={item} />
        ))}
      </SlickSlider>
    )
  }

  if (loaded) {
    return (
      <Container variant={['-xl']}>
        {isDesktop ? (
          <>
            <Columns className={styles.locations}>
              {services &&
                services.map(
                  (item, index) =>
                    index < 4 && (
                      <Column spans={3} key={`service-${index}`}>
                        <Item item={item} />
                      </Column>
                    )
                )}
            </Columns>

            <Columns className={styles.locations} variant={['-align-center']}>
              {services &&
                services.map(
                  (item, index) =>
                    index > 3 &&
                    index <= 6 && (
                      <Column spans={3} key={`service-${index}`}>
                        <Item item={item} />
                      </Column>
                    )
                )}
            </Columns>

            <Columns className={styles.locations} variant={['-align-center']}>
              {services &&
                services.map(
                  (item, index) =>
                    index > 6 && (
                      <Column spans={3} key={`service-${index}`}>
                        <Item item={item} />
                      </Column>
                    )
                )}
            </Columns>
          </>
        ) : (
          <Columns variant={['-align-center']}>
            {services &&
              services.map((item, index) => (
                <Column
                  spans={20}
                  key={`service-${index}`}
                  className={styles.column}
                >
                  <Item item={item} />
                </Column>
              ))}
          </Columns>
        )}
      </Container>
    )
  }
  return
}

export default Services
